let JackpotModal = {
    render: async () => {
        let view =  /*html*/`
        <div id="jackpot-modal" class="modal-window popup hidden" style="z-index:9999;">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="jackpot-price">
                        <span id="description"></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
        `
        return view
    },
    after_render: async () => {
        
    },
    show: (hideAfter, jackpotPrice, type) => {
        if (jackpotPrice) {
            $('#jackpot-modal .jackpot-price>span:last-child').text(Number.parseFloat(jackpotPrice).toFixed(2));
            $('#description').text(`${_t('Keni fituar')} ${type} jackpot:`);
            $('#jackpot-modal .jackpot-price').show();
        } else {
            $('#jackpot-modal .jackpot-price').hide();
        }

        $('#jackpot-modal').addClass('show');
        $('body').addClass('modal-open');

        if(typeof hideAfter !== 'undefined' && hideAfter !== -1) {
            setTimeout(() => {
                JackpotModal.hide();
            }, hideAfter);
        }
    },
    hide: () => {
        $('body').removeClass('modal-open');
        $('#jackpot-modal').removeClass('show');
    }
}

export default JackpotModal;
